import _ from 'lodash'

import { firebaseDb as db } from '../firebase'
import { asyncRequest, asyncSuccess, asyncFail, selectContact, cleanMessages } from '../actions'

const uuid = require('uuid/v1')

// action types
export const IMPORT_CONTACTS = 'IMPORT_CONTACTS'

// action creators
export const fetchContacts = projectId => {
  return dispatch => {
    dispatch(asyncRequest('fetchContacts'))

    const contactsRef = db.collection('projects').doc(projectId).collection('contacts').where('deleted', '==', false)

    // contactsRef.get().then(contactsSnap => {
    contactsRef.onSnapshot(contactsSnap => {
      const contacts = {}
      contactsSnap.forEach(doc => {
        contacts[doc.id] = doc.data()
        contacts[doc.id].id = doc.id
      })
      dispatch(asyncSuccess('fetchContacts', { contacts }, null))
    })
    // .catch(error => {
    //   dispatch(asyncFail('fetchContacts', error.code))
    //   dispatch(cleanMessages())
    // })
  }
}

export const createContact = (projectId, fields) => {
  return dispatch => {
    dispatch(asyncRequest('createContact'))

    const contactId = uuid()
    const newContact = {
      ...fields,
      status: 0,
      id: contactId,
      deleted: false
    }

    const contactsRef = db.collection('projects').doc(projectId).collection('contacts')
    contactsRef
      .doc(contactId)
      .set(newContact)
      .then(() => {
        dispatch(
          asyncSuccess('createContact', { contact: { [contactId]: newContact } }, 'Contact was successfully created')
        )
        dispatch(selectContact(null))
      })
      .catch(error => {
        dispatch(asyncFail('createContact', error.message))
        dispatch(cleanMessages())
      })
  }
}

export const editContact = (projectId, contactId, fields, action) => {
  return dispatch => {
    dispatch(asyncRequest('editContact'))

    const contactRef = db.collection('projects').doc(projectId).collection('contacts').doc(contactId)
    contactRef
      .update({ ...fields })
      .then(() => {
        dispatch(asyncSuccess('editContact', { contactId, fields }, 'Contact saved successfully'))
        dispatch(cleanMessages())
        if (action === 'edit') dispatch(selectContact(null))
      })
      .catch(error => {
        dispatch(asyncFail('editContact', error))
        dispatch(cleanMessages())
      })
  }
}

export const importContacts = (contacts, projectId) => {
  return dispatch => {
    dispatch(asyncRequest('importContacts'))

    const newContacts = {} // for Firebase
    const newContactsWithIds = {} // for Redux

    // Firestore: 'cannot write more than 500 entities in a single call'
    const contactsChunks = _.chunk(contacts, 500)
    const contacstRef = db.collection('projects').doc(projectId).collection('contacts')

    const chunksPromises = contactsChunks.map(chunk => {
      // new batch
      var batch = db.batch()

      chunk.forEach(newContact => {
        newContact.deleted = false
        const id = uuid()

        newContacts[id] = newContact

        newContactsWithIds[id] = newContact
        newContactsWithIds[id].id = id

        batch.set(contacstRef.doc(id), newContact)
      })
      return batch.commit()
    })

    Promise.all(chunksPromises)
      .then(response => {
        dispatch(asyncSuccess('importContacts', { newContacts, projectId }, 'All contacts were imported'))
        dispatch(cleanMessages())
      })
      .catch(error => {
        dispatch(asyncFail('importContacts', error))
        dispatch(cleanMessages())
      })
  }
}

export const contactIsInCall = (isInCall, contactId, projectId) => {
  return dispatch => {
    // dispatch(asyncRequest('contactIsInCall'))

    const contactRef = db.collection('projects').doc(projectId).collection('contacts').doc(contactId)
    contactRef.update({ isInCall })
    // .then(() => {
    //   dispatch(asyncSuccess('contactIsInCall', { projectId, contactId, isInCall }))
    //   dispatch(cleanMessages())
    // })
    // .catch(error => {
    //   dispatch(asyncFail('contactIsInCall', error))
    //   dispatch(cleanMessages())
    // })
  }
}

export const deleteContacts = (projectId, contactIds) => {
  return dispatch => {
    dispatch(asyncRequest('deleteContacts'))

    const contactsRef = db.collection('projects').doc(projectId).collection('contacts')

    var batch = db.batch()

    contactIds.forEach(contactId => {
      batch.update(contactsRef.doc(contactId), { deleted: true })
    })

    batch
      .commit()
      .then(() => {
        dispatch(asyncSuccess('deleteContacts', { contactIds }, 'Contacts deleted'))
        dispatch(cleanMessages())
      })
      .catch(error => {
        dispatch(asyncFail('deleteContacts', error))
        dispatch(cleanMessages())
      })
  }
}

// helper function - for 'fixing' something in all Contacts in specified Project,
// for example: adding new field into each Contact doc
export const fixContacts = projectId => {
  return dispatch => {
    dispatch(asyncRequest('fixContacts'))

    const contactsRef = db.collection('projects').doc(projectId).collection('contacts')

    contactsRef.get().then(contactsSnap => {
      const contactsChunks = _.chunk(contactsSnap.docs, 500)

      const chunksPromises = contactsChunks.map(chunk => {
        var batch = db.batch()

        chunk.forEach(contactDoc => {
          // do whatever you want here
          batch.update(contactsRef.doc(contactDoc.id), { deleted: false })
        })

        return batch.commit()
      })

      Promise.all(chunksPromises)
        .then(() => {
          dispatch(asyncSuccess('fixContacts', null, 'Contacts fixed'))
          dispatch(cleanMessages())
        })
        .catch(error => {
          dispatch(asyncFail('fixContacts', error))
          dispatch(cleanMessages())
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/contacts.js